<div class="customizer-container" fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="10px">


  <!-- Controls Section (Dropdown) -->
  <div class="controls-dropdown" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px">


    <!-- Canvas for T-shirt Customizer -->
    <div fxFlex>
      <canvas #tshirtCanvas></canvas>
    </div>

  </div>
  <!-- Customize Product Button -->
  <div>
    <button (click)="toggleCustomizer()">Customize Product</button>
  </div>
  <div *ngIf="isCustomizerOpen" class="controls" fxLayout="column" fxLayout.xs="column" fxLayoutGap="15px"
    (clickOutside)="closeCustomizer()">

    <!-- Image Upload -->
    <div fxLayout.xs="column" fxLayoutGap.xs="10">
      <div fxLayout="column" fxLayoutAlign="start start" fxFlex="39%" fxFlex.md="40%" fxFlex.sm="50%">
        <label for="imageUpload">Import Image:</label>
        <input id="imageUpload" type="file" (change)="onImageUpload($event)" />
        <label for="gifUpload">Import GIF:</label>
        <input id="gifUpload" type="file" (change)="onGifUpload($event)" />

        <!-- Filter Options Currently Progressed -->
        <!--         
       
        <label for="brightness">Brightness:</label>
        <input type="range" id="brightness" min="-1" max="1" step="0.1" (input)="onBrightnessChange($event)">

       
        <label for="saturation">Saturation:</label>
        <input type="range" id="saturation" min="0" max="2" step="0.1" (input)="onSaturationChange($event)">

       
        <label for="opacity">Opacity:</label>
        <input type="range" id="opacity" min="0" max="1" step="0.1" (input)="onOpacityChange($event)"> -->

      </div>

      <!-- Text Input -->
      <div fxLayout="column" fxLayoutAlign="start start" fxFlex="39%" fxFlex.md="40%" fxFlex.sm="50%">
        <input type="text" [(ngModel)]="textInput" placeholder="Enter Text" />
        <button (click)="addText()">Add Text</button>
      </div>

      <!-- Text Color Picker -->
      <div fxLayout="column" fxLayoutAlign="start start" fxFlex="39%" fxFlex.md="40%" fxFlex.sm="50%">
        <label for="textColor">Text Color:</label>
        <input id="textColor" type="color" [(ngModel)]="textColor" (input)="changeTextColor()" />

        <label for="fontFamily">Font Family:</label>
        <select id="fontFamily" [(ngModel)]="selectedFontFamily" (change)="changeFontFamily()">
          <option value="Arial">Arial</option>
          <option value="Times New Roman">Times New Roman</option>
          <option value="Courier New">Courier New</option>
          <option value="Georgia">Georgia</option>
          <option value="Verdana">Verdana</option>
          <option value="Roboto">Roboto</option>
          <option value="Helvetica">Helvetica</option>
          <option value="Comic Sans MS">Comic Sans MS</option>
          <option value="Trebuchet MS">Trebuchet MS</option>
          <option value="Garamond">Garamond</option>
        </select>
      </div>


    </div>
    <div>
      <!-- Delete Selected Item -->
      <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="space-between start" FxLayoutGap="10px">
        <button (click)="deleteSelectedItem()">Delete Selected Item</button>
        <button (click)="saveCanvas()">Save Canvas</button>
        <button (click)="downloadCanvas()">Download as Image</button>
        <!-- <button (click)="undo()">Undo</button>
<button (click)="redo()">Redo</button> -->

      </div>

    </div>
  </div>

</div>